import { PaymentType } from '../requests/caipirinha-api/interfaces/order.interface';

type PaymentTypes = PaymentType.BOLETO | PaymentType.PIX | PaymentType.PIX_MKT;
export const pages = {
  [PaymentType.BOLETO]: 'boleto',
  [PaymentType.PIX]: 'pix',
  [PaymentType.PIX_MKT]: 'pix',
};
export const getPaymentPage = (paymentId?: string) =>
  paymentId && paymentId in pages ? pages[paymentId as PaymentTypes] : '';
export const names = {
  [PaymentType.BOLETO]: 'boleto',
  [PaymentType.PIX]: 'código pix',
  [PaymentType.PIX_MKT]: 'código pix',
};
export const getPaymentName = (paymentId?: number | string) => {
  if (!paymentId) return '';
  const payment = paymentId.toString().toLowerCase();
  return payment in names ? names[payment as PaymentTypes] : '';
};
export const isBoleto = (paymentId: number | string) =>
  paymentId.toString() === PaymentType.BOLETO;
export const isPix = (paymentId: number | string) => {
  const payment = paymentId.toString().toLowerCase();
  return payment === PaymentType.PIX || payment === PaymentType.PIX_MKT;
};
